module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0011.jpg?v=d73bd560";